<script>
export default {
  props: ["value"],
  data() {
    return {};
  },

  methods: {},

  render() {
    return <span class="json-value json-value__undefined">undefined</span>;
  },
};
</script>
